var o = ":host,:root{--ngc-accordion-group-divider-color: var(--color-stroke-primary);--ngc-accordion-group-divider: 1px solid var(--ngc-accordion-group-divider-color)}";
export { o as default };